export type EnvKey = 'dev' | 'beta' | 'prod';

export interface AppEnvironment {
  sip: {
    server: string;
    routes: string[] | undefined;
    encodeKey: string;
    iceUrls: string[] | undefined;
  };
  system: {
    evePortalApiUrl: string;
    presenceVoiceUrl: string;
  };
}

// Static configs for all environments
export const allConfigs: Record<EnvKey, AppEnvironment> = {
  dev: {
      sip: {
        server: 'wss://connect.dev.iameve.co.uk', //TODO: need to fix webRtcBridge for subscription
        // server: 'wss://webrtc.dev.iameve.co.uk', 
        routes:[
        ],
        iceUrls: [
          "stun:webrtc.dev.iameve.co.uk:3478"
        ],
        encodeKey: 'RHFWbXkyWVJVVXlKYjlrR3JaU3gydDNBUEpEdDJ0dUc='
      },
      system: {
        evePortalApiUrl: 'https://eve-portal-api-dev.azurewebsites.net',
        presenceVoiceUrl: 'https://eve-voice-presence-api-dev.azurewebsites.net'
      }
    },
    beta: {
      sip: {
        server: 'wss://webrtc.stg.iameve.co.uk',
        routes: [
        ],
        iceUrls: [
          "stun:webrtc01.stg.iameve.co.uk:3478",
          "stun:webrtc02.stg.iameve.co.uk:3478"
        ],
        encodeKey: 'RHFWbXkyWVJVVXlKYjlrR3JaU3gydDNBUEpEdDJ0dUc='
      },
      system: {
        evePortalApiUrl: 'https://eve-portal-api-beta.azurewebsites.net',
        presenceVoiceUrl: 'https://eve-voice-presence-api-beta.azurewebsites.net'
      }
    },
    prod: {
      sip: {
        server: 'wss://webrtc.iameve.co.uk',
        routes: [
        ],
        iceUrls: [
          "stun:webrtc01.iameve.co.uk:3478",
          "stun:webrtc02.iameve.co.uk:3478"
        ],
        encodeKey: 'RHFWbXkyWVJVVXlKYjlrR3JaU3gydDNBUEpEdDJ0dUc='
      },
      system: {
        evePortalApiUrl: 'https://eve-portal-api.azurewebsites.net',
        presenceVoiceUrl: 'https://eve-voice-presence-api.azurewebsites.net'
      }
    },
};
